import { __spreadArrays } from "tslib";
/**
 * EventEmitterStripped
 * lightweight event emitter
 */
var EventEmitterStripped = /** @class */ (function () {
    function EventEmitterStripped() {
        this.listeners = {};
    }
    EventEmitterStripped.prototype.on = function (event, handler) {
        var _this = this;
        this.listeners[event] = __spreadArrays((this.listeners[event] || []), [handler]);
        return function () { return _this.off(event, handler); };
    };
    EventEmitterStripped.prototype.off = function (event, handler) {
        if (this.listeners[event]) {
            this.listeners[event].splice(this.listeners[event].indexOf(handler) >>> 0, 1);
        }
    };
    EventEmitterStripped.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this.listeners;
        (listeners[event] || []).slice().map(function (handler) { return handler.apply(void 0, args); });
        (listeners["*"] || []).slice().map(function (handler) { return handler.apply(void 0, args); });
    };
    return EventEmitterStripped;
}());
export default EventEmitterStripped;
//# sourceMappingURL=EventEmitterStripped.js.map